// extracted by mini-css-extract-plugin
export default {"buttonStyle":"customTransferList_buttonStyle__BxyH9","buttonContainer":"customTransferList_buttonContainer__e9rox"};